module.exports = __webpack_public_path__ + "media/images/p-about/feature/icon3-ae77dffc77d98037223fa9d6b9516fa6.svg";